import React from "react"

import * as s from "./SimpleHeader.module.scss"

export const SimpleHeader = ({ title, subTitle, tall }) => {
  return (
    <div className={`${s.Wrapper} ${tall && s.Wrapper___tall}`}>
      <div className={s.Inner}>
        {subTitle && <span>{subTitle}</span>}
        {title && <h1>{title}</h1>}
      </div>
    </div>
  )
}
